import RequestAbstract from "./RequestAbstract";

export default class Transaction extends RequestAbstract {
    get link() {
        return this.links.transactions;
    }
}
